module.exports = __webpack_public_path__ + "img/bg_danbao@3x.1b7966a8.png";